import React, { useState, useContext } from "react";

import GeneralPageContext from "../../../templates/GeneralPageContext";
import t from "../../../lib/translate";
import { Headline } from "../../../components/Headline";
import { TeaserCard } from "../../../components/teaser-components/TeaserCard/TeaserCard";
import { TeaserLayoutWrapper } from "../../../components/teaser-components/TeaserLayoutWrapper/TeaserLayoutWrapper";

import * as styles from "./BranchAndApplicationTeaser.module.less";
import { ApplicationAndBranchListing } from "../../../page-components/application-and-branch/ApplicationAndBranchListing/ApplicationAndBranchListing";
import { useMemo } from "react";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";
import grid from "../../../../static/assets/images/infra-grid-rectangle-hover.png";

import { useIsTablet, useIsDesktop } from "../../../lib/hooks/mediaQueries";

export function BranchAndApplicationTeaser({
    data: {
        anker,
        tagline,
        headline,
        semanticOfHeadline,
        semanticOfTeaserHeadline,
        teaser = [],
        background
    }
}) {
    const {
        stdPages: { pageApplicationAndBranch },
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    const [showFullList, setShowFullList] = useState(false);

    //! Do not set this to false ! In that case the showAll-Button-Animation would trigger on load.
    const [hovered, setHovered] = useState(true);

    const isSmaller1200 = useIsDesktop();
    const isMobile = useIsTablet();

    const initialTeaserCount =
        !isMobile &&
        (showAnchorNavigation || (!showAnchorNavigation && isSmaller1200))
            ? 2
            : 3;

    const initialTeaserShown = useMemo(
        () => teaser.slice(0, initialTeaserCount),
        [teaser]
    );

    return (
        <TeaserLayoutWrapper
            anker={anker}
            tagline={tagline}
            headline={headline}
            semanticOfHeadline={semanticOfHeadline}
            background={background}
            overviewPage={{
                label: t("application.list.showAll"),
                link: pageApplicationAndBranch.url
            }}
        >
            {!showFullList ? (
                <div
                    className={gcs(styles.applicationTeaserList, [
                        showAnchorNavigation,
                        styles.anchored
                    ])}
                >
                    {initialTeaserShown.map((teaserElement, index) => {
                        const {
                            teaserImage: image,
                            teaserTagline: tagline,
                            teaserHeadline: headline,
                            teaserText: text,
                            teaserLink: link,
                            teaserUrl: url
                        } = teaserElement;

                        return (
                            <TeaserCard
                                key={teaserElement.id}
                                cardClass={styles.applicationTeaserCard}
                                teaserData={{
                                    semanticOfHeadline:
                                        semanticOfTeaserHeadline,
                                    image,
                                    tagline,
                                    headline,
                                    text,
                                    link,
                                    url,
                                    gridSize: "s"
                                }}
                            />
                        );
                    })}

                    {teaser.length > initialTeaserCount && (
                        <button
                            onClick={() => setShowFullList(true)}
                            className={gcs(
                                styles.showAll,
                                !hovered ? styles.reverseAnimation : ""
                            )}
                            key={"application_list_show_more"}
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                        >
                            <div className={styles.imageWrap}>
                                <figure>
                                    <img
                                        src={grid}
                                        alt={t`application.list.grid`}
                                        loading="lazy"
                                        width="350"
                                        height="212"
                                    />
                                </figure>
                            </div>
                            <Headline
                                semanticOfHeadline={semanticOfTeaserHeadline}
                            >
                                {t`application.list.showMore`}
                            </Headline>

                            <span className={styles.showMoreLabel}>
                                {t("application.list.showMore.buttonLabel")}
                            </span>
                        </button>
                    )}
                </div>
            ) : (
                <ApplicationAndBranchListing items={teaser} />
            )}
        </TeaserLayoutWrapper>
    );
}
